// Update Lookbook Published
export const UPDATE_LOOKBOOK_PUBLISHED_REQUEST = 'UPDATE_LOOKBOOK_PUBLISHED_REQUEST';
export const UPDATE_LOOKBOOK_PUBLISHED_DONE = 'UPDATE_LOOKBOOK_PUBLISHED_DONE';
export const UPDATE_LOOKBOOK_PUBLISHED_FAILED = 'UPDATE_LOOKBOOK_PUBLISHED_FAILED';
export const UPDATE_LOOKBOOK_PUBLISHED_CLEAR_ERRORS = 'UPDATE_LOOKBOOK_PUBLISHED_CLEAR_ERRORS';
export const UPDATE_LOOKBOOK_PUBLISHED_RESET = 'UPDATE_LOOKBOOK_PUBLISHED_RESET';